import { createContext } from 'react';

import { HistogramChartToolbarConfig } from '../types/histogram.js';

export const HistogramToolbarContext = createContext<
  HistogramChartToolbarConfig | undefined
>(undefined);
